export const siteConfig = {
    humoristName: "Antoine Officieux",
    tagline: "",
    socialLinks: {
        instagram: "https://instagram.com/antoineofficieux",
        youtube: "https://www.youtube.com/channel/UC3C_hjrxM6ta42S_l0s2yUA",
        tiktok: "https://tiktok.com/@antoineofficieux",
        thread: "https://www.threads.net/@antoineofficieux?xmt=AQGzwwtp-tuoBOuGUdulpIf-K7Y_MX_zUYchwVckn2BGq_g",
    },
    contactEmail: "antoineofficieux.collaborations@gmail.com",
    aboutMe: "I'm a stand-up comedian with 10 years of experience...",
    profileImage: "https://picsum.photos/400/400",
    demoVideo: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    youtubePlaylist: "UU3C_hjrxM6ta42S_l0s2yUA",
};